const menu = {
    label: 'Menu Principal',
    icon: 'pi pi-fw pi-file-excel',
    to: '/mapaparceiros/exportacaoxls',
    rules: ['MAPAPARC-PAR-00'],
};

export default menu;